<div class="card-container">
  <div class="card"
       *ngFor="let item of cardData">
    <span class="border-content">
      <i class="{{ item.icon }}"></i>
    </span>
    <h6>{{ item.title }}: {{ item.cant }}</h6>
  </div>
</div>
